module.exports = __webpack_public_path__ + "img/logost.959fc550.png";